// USER
import {
  ADD_USER,
  CREATE_USER,
  CREATE_USER_SUCCESS,
  CANCEL_CREATE_USER,
  REFRESH_USER_INFO,
  GET_USER,
  GET_USER_LOGS,
  GET_USER_LOGS_SUCCESS,
  GET_USER_SUCCESS,
  GET_USERS,
  GET_USERS_SUCCESS,
  SELECT_USER,
  EDIT_USER,
  CANCEL_EDIT_USER,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  SET_USER_CLIENT,
  SET_USER_CLIENT_SUCCESS,
  DELETE_USER_CLIENT,
  DELETE_USER_CLIENT_SUCCESS,
  SET_USER_ROLE,
  SET_USER_ROLE_SUCCESS,
  DELETE_USER_ROLE,
  DELETE_USER_ROLE_SUCCESS,
  USERS_ERROR,
  CHANGE_USER_ROLE,
  CHANGE_USER_ROLE_SUCCESS,
  SYNC_INIT_START,
  SYNC_INIT_STOP,
  SYNC_META_START,
  SYNC_META_STOP,
  SYNC_INIT,
  SYNC_META,
  CHANGE_USER_PASSWORD,
  CHANGE_USER_PASSWORD_SUCCESS,
  GET_PAGINATED_USER_LOGS,
  GET_PAGINATED_USER_LOGS_SUCCESS,
  USER_EMAIL_CHANGE,
} from '../constants/action-types/users';

const { REACT_APP_REDIRECTURI } = process.env;

export const getUser = id => ({
  type: GET_USER,
  id,
});

export const getUserSuccess = data => ({
  type: GET_USER_SUCCESS,
  data,
});

export const getUserLogs = id => ({
  type: GET_USER_LOGS,
  id,
});

export const getUserLogsSuccess = data => ({
  type: GET_USER_LOGS_SUCCESS,
  data,
});

export const getPaginatedUserLogs = data => ({
  type: GET_PAGINATED_USER_LOGS,
  data,
});

export const getPaginatedUserLogsSuccess = data => ({
  type: GET_PAGINATED_USER_LOGS_SUCCESS,
  data,
});

export const getUsers = () => ({
  type: GET_USERS,
});

export const getUsersSuccess = data => ({
  type: GET_USERS_SUCCESS,
  data,
});

export const selectUser = id => ({
  type: SELECT_USER,
  id,
});

export const editUser = () => ({
  type: EDIT_USER,
});

export const cancelEditUser = id => ({
  type: CANCEL_EDIT_USER,
  id,
});

export const deleteUser = id => ({
  type: DELETE_USER,
  id,
});

export const deleteUserSuccess = () => ({
  type: DELETE_USER_SUCCESS,
});

export const updateUser = (uid, data) => ({
  type: UPDATE_USER,
  uid,
  data,
});

export const updateUserSuccess = data => ({
  type: UPDATE_USER_SUCCESS,
  data,
});

export const setUserClient = (uid, cid) => ({
  type: SET_USER_CLIENT,
  uid,
  cid,
});

export const setUserClientSuccess = (id, cid) => ({
  type: SET_USER_CLIENT_SUCCESS,
  id,
  cid,
});

export const deleteUserClient = (uid, cid) => ({
  type: DELETE_USER_CLIENT,
  uid,
  cid,
});

export const deleteUserClientSuccess = (id, cid) => ({
  type: DELETE_USER_CLIENT_SUCCESS,
  id,
  cid,
});

export const setUserRole = (uid, rid, cid, appid) => ({
  type: SET_USER_ROLE,
  uid,
  rid,
  cid,
  appid,
});

export const setUserRoleSuccess = id => ({
  type: SET_USER_ROLE_SUCCESS,
  id,
});

export const deleteUserRole = (uid, data) => ({
  type: DELETE_USER_ROLE,
  uid,
  data,
});

export const deleteUserRoleSuccess = id => ({
  type: DELETE_USER_ROLE_SUCCESS,
  id,
});

export const userEmailChange = () => ({
  type: USER_EMAIL_CHANGE,
});

export const usersError = () => ({
  type: USERS_ERROR,
});

export const addUser = () => ({
  type: ADD_USER,
});

export const createUser = data => ({
  type: CREATE_USER,
  data,
});

export const createUserSuccess = data => ({
  type: CREATE_USER_SUCCESS,
  data,
});

export const cancelCreateUser = () => ({
  type: CANCEL_CREATE_USER,
});

export const refreshUserInfo = data => ({
  type: REFRESH_USER_INFO,
  data,
});

export const changeUserRole = (uid, data) => ({
  type: CHANGE_USER_ROLE,
  uid,
  data,
});

export const changeUserRoleSuccess = id => ({
  type: CHANGE_USER_ROLE_SUCCESS,
  id,
});

export const syncInit = () => ({
  type: SYNC_INIT,
});

export const syncInitStart = () => ({
  type: SYNC_INIT_START,
});

export const syncInitStop = () => ({
  type: SYNC_INIT_STOP,
});

export const syncMeta = () => ({
  type: SYNC_META,
});

export const syncMetaStart = () => ({
  type: SYNC_META_START,
});

export const syncMetaStop = () => ({
  type: SYNC_META_STOP,
});

export const changeUserPassword = (email, redirect = false) => ({
  type: CHANGE_USER_PASSWORD,
  redirect,
  changePasswordRequest: {
    email,
    redirectUrl: REACT_APP_REDIRECTURI,
    appName: 'EpiPortal',
  },
});

export const changeUserPasswordSuccess = () => ({
  type: CHANGE_USER_PASSWORD_SUCCESS,
});
